import { render, staticRenderFns } from "./CustomerAnalysis.vue?vue&type=template&id=b636f5b8&scoped=true&"
import script from "./CustomerAnalysis.vue?vue&type=script&lang=js&"
export * from "./CustomerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAnalysis.vue?vue&type=style&index=0&id=b636f5b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b636f5b8",
  null
  
)

export default component.exports